<template>
    <div>
        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>盘面活跃</span>
                <el-button v-if="dataList.length==0" style="float: right; padding: 3px 0" type="text"
                           @click="openReverserOderDialog">新增
                </el-button>
            </div>
            <el-table class="active-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column fixed prop="pair" label="交易对" width="150"></el-table-column>
                <el-table-column label="禁用">
                    <template slot-scope="scope">
                        <el-switch active-color="#13ce66" :value="scope.row.status"
                                   @change="updateStatus(scope.row, $event)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minOnceAmount" label="单次下单最小值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxOnceAmount" label="单次下单最大值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minCreateIntervalTime" label="下单最小间隔" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒')"></el-table-column>
                <el-table-column prop="maxCreateIntervalTime" label="下单最大间隔" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒')"></el-table-column>
                <el-table-column prop="minCancelIntervalTime" label="撤单最小间隔" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒')"></el-table-column>
                <el-table-column prop="maxCancelIntervalTime" label="撤单最大间隔" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒')"></el-table-column>
                <el-table-column prop="createMinTimes" label="下单执行最小次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createMaxTimes" label="下单执行最大次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cancelMinTimes" label="撤单执行最小次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cancelMaxTimes" label="撤单执行最大次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minPosition" label="最小档位" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxPosition" label="最大档位" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="openUpdateReverserOderDialog(scope.row)">
                            修改
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="activeData.pair"
                              :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="activeData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">单次下单最小值</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.minOnceAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">单次下单最大值</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.maxOnceAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单最小间隔</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.minCreateIntervalTime"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单最大间隔</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.maxCreateIntervalTime"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">撤单最小间隔</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.minCancelIntervalTime"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">撤单最大间隔</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.maxCancelIntervalTime"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单执行最小次数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.createMinTimes"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单执行最大次数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.createMaxTimes"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">撤单执行最小次数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.cancelMinTimes"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">撤单执行最大次数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.cancelMaxTimes"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小档位</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.minPosition"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大档位</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="activeData.maxPosition"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="createActiveOder">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'ActiveOrder',
        props: {dataList: Array, pair: String},
        data() {
            return {
                loading: false,
                dialogVisible: false,
                dialogTitle: "",
                activeData: { //数据对象
                    id: null,
                    pair: "",
                    userId: "",
                    minOnceAmount: "",
                    maxOnceAmount: "",
                    minCreateIntervalTime: "",
                    maxCreateIntervalTime: "",
                    minCancelIntervalTime: "",
                    maxCancelIntervalTime: "",
                    createMinTimes: "",
                    createMaxTimes: "",
                    cancelMinTimes: "",
                    cancelMaxTimes: "",
                    minPosition: "",
                    maxPosition: "",
                    status: true
                }
            };
        },
        methods: {
            queryActiveConfigList() {
                this.$emit('refreshData', this.pair);
            },
            updateStatus(row, value) {
                api.updateActiveStatus({id: row.id, status: value}).then(response => {
                    if (response.code == 0) {
                        this.queryActiveConfigList();
                    } else {
                        this.$message.success('操作失败');
                    }
                });
            },
            createActiveOder() {
                if (this.activeData.pair == "") {
                    this.$message.success('请输入交易对!');
                    return
                }
                if (this.activeData.userId == "") {
                    this.$message.success('请输入用户id!');
                    return
                }
                if (this.activeData.minOnceAmount == "") {
                    this.$message.success('请输入单次下单最小值!');
                    return
                }
                if (this.activeData.maxOnceAmount == "") {
                    this.$message.success('请输入单次下单最大值!');
                    return
                }
                if (this.activeData.minCreateIntervalTime == "") {
                    this.$message.success('请输入下单最小间隔!');
                    return
                }
                if (this.activeData.maxCreateIntervalTime == "") {
                    this.$message.success('请输入下单最大间隔!');
                    return
                }
                if (this.activeData.minCancelIntervalTime == "") {
                    this.$message.success('请输入撤单最小间隔!');
                    return
                }
                if (this.activeData.maxCancelIntervalTime == "") {
                    this.$message.success('请输入撤单最大间隔!');
                    return
                }
                if (this.activeData.createMinTimes == "") {
                    this.$message.success('请输入下单执行最小次数!');
                    return
                }
                if (this.activeData.createMaxTimes == "") {
                    this.$message.success('请输入下单执行最大次数!');
                    return
                }
                if (this.activeData.cancelMinTimes == "") {
                    this.$message.success('请输入撤单执行最小次数!');
                    return
                }
                if (this.activeData.cancelMaxTimes == "") {
                    this.$message.success('请输入撤单执行最大次数!');
                    return
                }
                if (this.activeData.minPosition == "") {
                    this.$message.success('请输入最小档位!');
                    return
                }
                if (this.activeData.maxPosition == "") {
                    this.$message.success('请输入最大档位!');
                    return
                }

                this.loading = true;
                api.updateActiveConfig(this.activeData).then(response => {
                    if (response.code == 0) {
                        this.dialogVisible = false;
                        this.$message.success(this.dialogTitle + '成功');
                        this.queryActiveConfigList();
                    } else {
                        this.$message.success(this.dialogTitle + '失败');
                    }
                });
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            },
            openReverserOderDialog() {
                this.activeData.pair = this.pair;
                this.dialogTitle = "增加";
                this.dialogVisible = true;
            },
            openUpdateReverserOderDialog(row) {
                this.activeData = { //数据对象
                    id: row.id,
                    pair: row.pair,
                    userId: row.userId,
                    minOnceAmount: row.minOnceAmount,
                    maxOnceAmount: row.maxOnceAmount,
                    minCreateIntervalTime: row.minCreateIntervalTime,
                    maxCreateIntervalTime: row.maxCreateIntervalTime,
                    minCancelIntervalTime: row.minCancelIntervalTime,
                    maxCancelIntervalTime: row.maxCancelIntervalTime,
                    createMinTimes: row.createMinTimes,
                    createMaxTimes: row.createMaxTimes,
                    cancelMinTimes: row.cancelMinTimes,
                    cancelMaxTimes: row.cancelMaxTimes,
                    minPosition: row.minPosition,
                    maxPosition: row.maxPosition,
                    status: row.status
                }
                this.dialogTitle = "修改";
                this.dialogVisible = true;
            },
            clearData() {
                this.loading = false;
                this.activeData = { //数据对象
                    id: null,
                    pair: this.pair,
                    userId: "",
                    minOnceAmount: "",
                    maxOnceAmount: "",
                    minCreateIntervalTime: "",
                    maxCreateIntervalTime: "",
                    minCancelIntervalTime: "",
                    maxCancelIntervalTime: "",
                    createMinTimes: "",
                    createMaxTimes: "",
                    cancelMinTimes: "",
                    cancelMaxTimes: "",
                    minPosition: "",
                    maxPosition: "",
                    status: true
                }
            },
            renderTipsHeader(h, {column}, index) {
                return h(
                    'div', [
                        h('span', column.label),
                        h('el-tooltip', {
                            props: {
                                effect: 'dark',
                                content: index,
                                placement: 'top'
                            },
                        }, [
                            h('i', {
                                class: 'el-icon-question',
                                style: 'color:#409EFF;margin-left:5px;'
                            })
                        ])
                    ]
                );
            }
        },
        created() {
            this.activeData.pair = this.pair;
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .active-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .active-table {
            margin-top: 30px;
        }
    }
</style>
